import script from "./numCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./numCard.vue?vue&type=script&lang=ts&setup=true"

import "./numCard.vue?vue&type=style&index=0&id=13f05d3a&scoped=true&lang=css"

import exportComponent from "E:\\vs\\integrate-system\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13f05d3a"]])

export default __exports__